var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "302px",
    height: "109px",
    viewBox: "37 71 302 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 5.50085323,
    y: 34.9541694,
    width: 81.5126434,
    height: 53.9292899,
    rx: 3.1104
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 81.5126434,
    height: 53.9292899,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0.0150091493,
    y: 0.0794065883,
    width: 23.0035681,
    height: 33.4561335,
    rx: 2.0736
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 23.0035681,
    height: 33.4561335,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "all-devices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(38.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "games-console-32",
    transform: "translate(135.020943, 60.920124)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    opacity: 0,
    transform: "translate(23.253607, 23.219555) rotate(90.000000) translate(-23.253607, -23.219555) ",
    x: 2.82721215e-14,
    y: 0,
    width: 46.5072137,
    height: 46.4391107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9868547,15.9648955 L14.5335043,15.9648955 L14.5335043,18.8658887 L11.6268034,18.8658887 L11.6268034,20.3171109 L14.5335043,20.3171109 L14.5335043,23.2195554 L15.9868547,23.2195554 L15.9868547,20.3171109 L18.8935556,20.3171109 L18.8935556,18.8658887 L15.9868547,18.8658887 L15.9868547,15.9648955 L15.9868547,15.9648955 Z M31.5071839,17.4161177 C30.4476915,17.4161177 29.5887614,18.2737901 29.5887614,19.3317311 C29.5887614,20.389672 30.4476915,21.2473444 31.5071839,21.2473444 C32.5666764,21.2473444 33.4256065,20.389672 33.4256065,19.3317311 C33.4256065,18.2737901 32.5681297,17.4161177 31.5071839,17.4161177 L31.5071839,17.4161177 Z M43.9943708,32.1387671 L39.9860303,13.3062564 C39.4148636,10.6243978 37.0444491,8.70878448 34.2990701,8.70878448 L12.2081436,8.70878448 C9.46276464,8.70878448 7.09235009,10.625849 6.52118337,13.3062564 L2.51284289,32.1387671 C1.92714267,34.8888331 3.68569669,37.5895577 6.4383424,38.1744002 C6.89033438,38.2701809 7.34523306,38.31662 7.79722505,38.31662 C9.68803395,38.31662 11.5134421,37.4966795 12.7705902,36.0265914 L17.5186861,30.4756664 L28.989981,30.4756664 L33.7380768,36.0265914 C34.995225,37.4952282 36.8206331,38.31662 38.7099886,38.31662 C39.1619806,38.31662 39.6183327,38.2701809 40.0703246,38.172949 C42.821517,37.5895577 44.580071,34.8873819 43.9943708,32.1387671 L43.9943708,32.1387671 Z M39.7665744,36.7551049 C39.4192237,36.8291172 39.0631528,36.866849 38.7085353,36.866849 C37.2188511,36.866849 35.8091012,36.2181527 34.8411698,35.0861994 L30.093074,29.5352744 L29.6599755,29.0244442 L28.989981,29.0244442 L17.5186861,29.0244442 L16.8486915,29.0244442 L16.4141397,29.5338232 L11.6660439,35.0847481 C10.6981125,36.2167015 9.28836258,36.8653978 7.79722505,36.8653978 C7.44260754,36.8653978 7.08799004,36.8291172 6.74063928,36.7551049 C4.77570951,36.3371529 3.51710804,34.4012225 3.93421961,32.4406213 L7.94256009,13.6081107 C8.36839176,11.6097777 10.1618262,10.1600067 12.2081436,10.1600067 L34.2990701,10.1600067 C36.3453875,10.1600067 38.1388219,11.6097777 38.5632003,13.6081107 L42.5715407,32.4406213 C42.7750098,33.3911718 42.5947943,34.3620395 42.0643214,35.1776264 C41.5338485,35.9932132 40.7185189,36.5519338 39.7665744,36.7551049 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44.7002928,32.5549713 C44.7002928,32.5549713 44.7002928,31.1606732 44.7002928,29.4436132 L44.7002928,0.105850006 L179.738553,0.105850006 L179.738553,33.4086742",
    id: "Path-4",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6135092,84.6390244 L137.021253,84.6390244",
    id: "Path-5",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(172.526760, 36.383129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.55271368e-15,30.6881449 C-3.55271368e-15,30.6881449 -3.55271368e-15,29.7697097 -3.55271368e-15,28.614969 L-3.55271368e-15,3.11142496 C-3.55271368e-15,1.3930324 1.39763195,0 3.10589848,0 L38.9006171,0 C40.6159575,0 42.0065156,1.39724835 42.0065156,3.10684876 L42.0065156,58.269441 C42.0065156,59.9853062 40.6092328,61.3762897 38.9015375,61.3762897 L8.32160759,61.3762898",
    id: "Path-6",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552,
    cx: 21.5033354,
    cy: 41.445658,
    rx: 12.0018616,
    ry: 11.9842866
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 22.0034129,
    cy: 15.4797036,
    rx: 1.5002327,
    ry: 1.49803583
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,95.5555447 L92.794392,95.5555447",
    id: "Path-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.036053,95.5555447 L129.222011,95.5555447",
    id: "Path-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 3.1104,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(218.018810, 64.766404)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-7",
    stroke: "#FFFFFF",
    mask: "url(#mask-4)",
    strokeWidth: 3.1104,
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    fill: "#FFFFFF",
    cx: 11.5167932,
    cy: 27.5433968,
    rx: 1.00015513,
    ry: 0.998690553
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(243.635508, 50.589474)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 46.2323709,
    cy: 24.9753875,
    rx: 1.90822761,
    ry: 1.91557888
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 10.1345922,
    cy: 24.9753875,
    rx: 1.90822761,
    ry: 1.91557888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3703429,2.02382024e-14 C28.3703429,2.02382024e-14 21.73135,-6.68862772e-15 15.0199,1.57634274e-15 C12.7823492,0.418233815 10.9853471,0.848228637 10.092036,3.41650624 C9.19872496,5.98478385 5.02326353,15.8407502 5.02326353,15.8407502 C5.02326353,15.8407502 0.451329058,19.6110909 0.451329058,22.0327247 C0.451329058,23.2749438 0.569259962,42.2052726 0.569259962,43.9636581 C0.569259962,45.7220436 1.02058902,46.9549777 2.31956212,47.2916955 C3.44040712,47.2916955 10.7631543,47.2916955 12.7356493,47.2916955 C13.3160911,47.2916955 15.0199,47.2916955 15.0199,45.5140581 C15.0199,43.7364206 15.0199,38.7788116 15.0199,38.7788116 L28.3703429,38.7788116",
    id: "Path-7",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8350759,2.02382024e-14 C55.8350759,2.02382024e-14 49.196083,-6.68862772e-15 42.484633,1.57634274e-15 C40.2470822,0.418233815 38.4500801,0.848228637 37.556769,3.41650624 C36.663458,5.98478385 32.4879965,15.8407502 32.4879965,15.8407502 C32.4879965,15.8407502 27.9160621,19.6110909 27.9160621,22.0327247 C27.9160621,23.2749438 28.033993,42.2052726 28.033993,43.9636581 C28.033993,45.7220436 28.485322,46.9549777 29.7842951,47.2916955 C30.9051401,47.2916955 38.2278873,47.2916955 40.2003823,47.2916955 C40.7808241,47.2916955 42.484633,47.2916955 42.484633,45.5140581 C42.484633,43.7364206 42.484633,38.7788116 42.484633,38.7788116 L55.8350759,38.7788116",
    id: "Path-7",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552,
    transform: "translate(41.875569, 23.645848) scale(-1, 1) translate(-41.875569, -23.645848) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.615194044,38.8618105 L55.8562849,38.8618105",
    id: "Path-8",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59370073,15.5565474 L50.7846102,15.5565474",
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeWidth: 1.5552
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDevices);
export default __webpack_public_path__ + "static/media/all-devices.4b80c17142921d2c48a54458838dbef6.svg";
export { ForwardRef as ReactComponent };